import toastr from 'react-hot-toast';
import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { generateURL } from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import type { SingleWorkspaceResponse } from 'types/Workspace';

const getWorkspace = async (workspaceID: string | undefined | null) => {
  const url = generateURL(
    SPARK_RESOURCE_TYPES.WORKSPACE_RECOMMENDED_MEMORIES,
    [],
    workspaceID
  );
  return fetchWrapper<SingleWorkspaceResponse>({
    url: url,
    method: 'GET',
  });
};
export function useWorkspaceRecommendedMemories(
  workspaceID: string | undefined | null
) {
  const response = useQuery(
    ['workspaceRecommendedMemories', workspaceID],
    () => getWorkspace(workspaceID),
    {
      enabled: Boolean(workspaceID),
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(`failed to Get workspace: ${error.message}`);
        }
      },
      refetchOnWindowFocus: false,
      staleTime: 10 * 60 * 1000, // 10 minutes
      cacheTime: 20 * 60 * 1000, // 20 minutes
    }
  );

  const workspace = response.data?.data;
  const recommendedMemories = workspace?.meta.recommendedMemories;

  return {
    workspace,
    recommendedMemories,
    ...response,
  };
}
